import gql from "graphql-tag";

export default gql`
	mutation approveBankAccount($bank_id: ID!) {
		approveBankAccount(bankId: $bank_id) {
			id
		}
	}
`;
